import React from 'react';

import { Flex } from '@chakra-ui/react';

const Mentions = () => <Flex>Mentions</Flex>;

export default Mentions;
